import { useCallback } from "react";
import { useAuth } from "oidc-react";
import { useLocation } from "react-router-dom";

export const useClarityCustomPageTracking = () => {
  const auth = useAuth();
  const location = useLocation();

  const trackPageView = useCallback(
    (customPageId) => {
      if (window.clarity && auth.userData) {
        const userId = auth.userData.profile?.preferred_username;

        let sessionId = sessionStorage.getItem("clarity_session_id");
        if (!sessionId) {
          sessionId = `${Date.now()}_${Math.random()
            .toString(36)
            .substring(2, 11)}`;
          sessionStorage.setItem("clarity_session_id", sessionId);
        }

        if (userId) {
          const pageId =
            customPageId || `${location.pathname}${location.search}`;
          window.clarity("identify", userId, sessionId, pageId);
          window.clarity("set", "pageTitle", pageId);
        }
      }
    },
    [auth.userData, location.pathname, location.search]
  );

  return trackPageView;
};

export const useClarityEventTracking = () => {
  const trackEvent = useCallback((eventName) => {
    if (window.clarity && eventName) {
      window.clarity("event", eventName);
    }
  }, []);

  return trackEvent;
};
